import * as React from "react";
import './Result.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import {Item} from "../Converter";

export default class Result extends React.Component {
    constructor() {
        super();
        this.state = {
            showCartModal: false,
            multiplier: 1
        }
    }

    getUrl(item) {
        return "/product/" + item.id;
    }

    componentDidMount() {
        this.resetModel();
    }

    resetModel = () => {
        this.setState({showCartModal: false, multiplier: 1});
    }

    handleMultiplierChange = (event) => {
        this.setState({multiplier: event.target.value});
    }

    render() {
        return (
            <div className="page">
                <AppHeader title="Productenlijst"/>

                <div className="page-middle">
                    <h1 className="result-title">Uw productenlijst.</h1>
                    <div className="table-wrapper">
                        <p className="table-title">Uw keuzes</p>
                        <table className="flat-table">
                            <thead>
                            <tr id="-1">
                                <th>Beslag<br/>uitvoering</th>
                                <th>Montage<br/>type</th>
                                <th>Draai<br/>type</th>
                                <th>Heng<br/>type</th>
                                <th>Luiksluiting</th>
                                <th>Luikvastzetter</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr id={"first"}>
                                <td>{this.props.VersionPick}</td>
                                <td>{this.props.MountingPick}</td>
                                <td>{this.props.RotatingPick}</td>
                                <td>{this.props.SuspensionPick.type + " " + (this.props.SuspensionPick?.fullVariant?.label ?? "")}</td>
                                <td>{this.props.ClosingPick}</td>
                                <td>{this.props.FastenerPick}</td>
                            </tr>
                            </tbody>
                        </table>
                        <p className="table-title">Resulterende producten</p>
                        <table className="flat-table full">
                            <thead>
                            <tr id="-1">
                                <th>Product<br/>nummer</th>
                                <th>Product</th>
                                <th>Aantal</th>
                                <th>Opmerking</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.productList.map((i: Item) => (
                                <tr id={i.id}>
                                    <td><a target={i.id} href={this.getUrl(i)}>{i.id}</a></td>
                                    <td>{i.name}</td>
                                    <td>{i.amount}×</td>
                                    <td>{i.remark}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="addToCart">
                        <button onClick={this.props.downloadPDF}>
                            Download als PDF
                        </button>
                        <button disabled={this.props.addedToCart} onClick={() => {
                            this.setState({showCartModal: true})
                        }}>
                            {this.props.addedToCart ?
                                <React.Fragment>Een moment, dit kan even duren</React.Fragment>
                                : <React.Fragment>
                                    <span className="ep-sprite ep-sprite-s BasketIcon"/>
                                    Voeg <b>{this.props.productList.length}</b> producten toe aan winkelmandje
                                </React.Fragment>
                            }
                        </button>
                    </div>
                    <p className="disclaimer">Dit is een hulpmiddel, u bent zelf verantwoordelijk voor het controleren
                        van uw bestelling</p>
                    {this.state.showCartModal ?
                        <div className="cartModalContainer"
                             onClick={(event) => {
                                 event.preventDefault();
                                 if (event.target === event.currentTarget) {
                                     this.resetModel();
                                 }
                             }}>
                            <div className="cartModal">
                                <header>Toevoegen aan winkelmandje</header>
                                <div className="cartModalBody"><br/>
                                    Dit kan even duren en verwijdert de huidige invoer.<br/>
                                    Als u de PDF wil downloaden, doet u dat voor deze handeling.<br/><br/>
                                    <hr/>
                                    <div className="multiForm">
                                        <label htmlFor="multiplier">Situatie aantal </label>
                                        <input id="multiplier" type="number"
                                               value={this.state.multiplier} onChange={this.handleMultiplierChange}/> <span>Hoe vaak deze situatie in uw winkelwagen komt te staan.</span>
                                    </div>
                                    <div className="buttons">
                                        <button className="button-divider" onClick={this.resetModel}>Afbreken</button>
                                        <button onClick={() => {
                                            this.props.addToCart(this.state.multiplier);
                                            this.resetModel();
                                        }}>Uitvoeren
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           last={true}
                />
            </div>
        );
    }
}
